import { observer } from 'mobx-react-lite';
import { FieldGroup, TextField } from '../../components/form';
import { Widget } from '../../components/surfaces';
import Account from './store/Account';

export default observer(function GeneralForm({
  account,
}: {
  account: Account;
}) {
  return (
    <Widget title="Account">
      <FieldGroup>
        <TextField
          disabled
          label="Email"
          sx={{ width: 384 }}
          value={account.email}
        />
        <TextField
          disabled
          label="User ID"
          sx={{ width: 272 }}
          value={account.id}
        />
        <TextField
          label="Developer Name"
          name="name"
          onChange={account.handleChangeAndSave}
          value={account.name}
        />
      </FieldGroup>
    </Widget>
  );
});
